import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

const NextSteps = ({ objective, employerMatch }) => {
  const { t } = useTranslation();
  const s = 'calc.nextSteps';

  const steps = [
    { key: '1', show: true },
    { key: '2', show: true },
    { key: '3', show: objective === 'home' },
    { key: '4', show: employerMatch === 'yes' },
    { key: '5', show: employerMatch === 'unknown' },
    { key: '6', show: true },
  ];

  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 700, color: '#1A1A1A', mb: 2, fontSize: '1.1rem' }}>
        {t(`${s}.title`)}
      </Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
        {steps.filter(s => s.show).map((step) => (
          <Box key={step.key} sx={{ display: 'flex', gap: 1.5, alignItems: 'flex-start' }}>
            <CheckCircleOutlineIcon sx={{ color: '#2E7D32', fontSize: 20, mt: 0.2 }} />
            <Typography sx={{ fontSize: 14, color: '#1A1A1A', lineHeight: 1.6 }}>
              {t(`${s}.${step.key}`)}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default NextSteps;
